import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" go foo ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" content ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_button, { onClick: _ctx.goFoo }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ], 64))
}